import React, { useState, useRef } from "react";
import "./OperatorCreation.scss";
import CustomForm from "../../UI/CustomForm/CustomForm";
import { CheckIfEmailExists, CreateOperator } from "../../../util/API/operator";
import { useSelector } from "react-redux";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { Box } from "@mui/material";
import BaseDrawer from "../../UI/BaseDrawer/BaseDrawer";

function OperatorCreation({ open, handleClose, onUserCreated }) {
  const [error, setError] = useState("");
  const [newUser, setNewUser] = useState("");
  const [loading, setLoading] = useState(false);
  const customFormRef = useRef();


  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;

  const [alert, setAlert] = useState({
    showAlert: false,
    message: '',
    severity: '',
    header: '',
    alertType: '',
    additionalInformation: '',
    confirmButton: null,
    countryAndState: false
  });

  const user = useSelector((state) => state.login.user);

  const handleConfirm = (data, formData) => {
    console.log("data--------",data);
    console.log("formData--------",formData);
    try {
        const requiredFields = formData
            .filter((field) => field.validation?.required)
            .map((field) => field.name);

        const missingFields = requiredFields.filter(
            (fieldName) => !data[fieldName] || data[fieldName].toString().trim() === ""
        );

        if (missingFields.length > 0) {
          return;        
        }

        // ✅ Email validation
        if (data.email) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if (!emailRegex.test(data.email.trim())) {
            setAlert({
              showAlert: true,
              message: `Please enter a valid email address.`,
              severity: "error",
              header: "Error"
            });
            return; // invalid email → stop here
          }
        }

      setAlert({
        ...alert,
        showAlert: true,
        severity: "confirm",
        additionalInformation: {
          "First Name": data.firstName,
          "Last Name": data.lastName,
          "Email": data.email,
          "Address": data.address,
          "City": data.city,
          "Country": data.country,
          "State": data.state,
          "Phone No": data.phoneno
        },
        alertType: "confirm",
        confirmButton: () => onSubmit(data, formData), // Pass `onSubmit` with data
        countryAndState: true
      })
    }
    catch (error) {
    }
  }

  const onSubmit = async (data, formData) => {
    setLoading(true);
    setNewUser("");
    setError("");
  
    console.log(data,formData)

    try {
      if (data.email !== "") {
        const emailExists = await CheckIfEmailExists(data);
        if (emailExists.callStatus === "0") {
          // console.log("Setting error alert");
          setAlert({
            showAlert: true,
            message: `${emailExists?.payload?.data?.header?.msg}`,
            severity: "error",
            header: "Error"
          });
          // throw new Error(`${emailExists.payload.data.header.msg}`);
          return;
        }
      }  
  
      const response = await CreateOperator(data, user.id, agent['User'].id);
      console.log(response.callStatus)
      if (response.callStatus === "1") {
        setNewUser("Operator created successfully");
        console.log("Setting success alert");
        setAlert({
          showAlert: true,
          message: "Operator created successfully",
          additionalInformation: {
            "Username" : response.newuseracct,  
            "Password" : response.newuserpassword,
            "PIN" : response.newuserpin
          },
          severity: "success",
          header: "Success",
          countryAndState: false
        });
      } else {
        console.log("Setting error alert");
        setError(`${response.msg}`);
        setAlert({
          showAlert: true,
          message: `${response.msg}`,
          severity: "error",
          header: "Error"
        });
      }
    } catch (error) {
      console.error(error);
      // setError("An error occurred while creating the user.");
      setAlert({
        showAlert: true,
        message: error,
        severity: "error",
        header: "Error"
      });
    }
    onUserCreated(); // Call the callback to reload the operator list
    setLoading(false);
  };

  // console.log(alert)

  return (
    <Box
      className="newcustomer-container offcanvas offcanvas-end dynamic-offcanvas"
      tabindex="-1"
      id="offcanvasRight2"
      aria-labelledby="offcanvasRightLabel"
    >
      <Box className="centered-content">
        <BaseDrawer
          open={open}
          handleClose={handleClose}
          height="90vh"
          title={"Add New Operator"}
        >
           <CustomAlert
          severity={alert.severity}
          show={alert.showAlert}
          header={alert.header}
          message={alert.message}
          onClick={() => {
            setAlert({ ...alert, showAlert: false }); 
            if (alert.severity === "success" || alert.severity === "error") 
              handleClose();
          }}
          confirmButton={alert.confirmButton} // Execute confirmation action
          additionalInformation={alert.additionalInformation}
          alertType={alert.alertType}
          countryAndState={alert.countryAndState}
          autoclose={false}
        />

        <Box className="customer-porfile-container-modal">
          <Box className="customer-photos"></Box>
          <Box className="customer-details"
          sx={{
            display: "flex",
            justifyContent: "center", /* Center the panels horizontally */
            alignItems: "flex-start", /* Align panels at the top */
          }}
          >
            <CustomForm
              ref={customFormRef}
              formName="newoperator"
              onSubmit={handleConfirm}
              fieldRendererType={"registration"}
              buttonAlignment={"right"}
              buttonText={"Add Operator"}
              loadingButtonText={"Adding Operator ..."}
              resetData={true}
              buttonInPanel={true}
              twoColumns={true}
              isRegistration={true}
            />
          </Box>
        </Box>
        </BaseDrawer>
      </Box>
    </Box>
  );
}

export default OperatorCreation;
